import { Divider, Grid, Paper, Typography } from "@material-ui/core";
import LoaderBar from "components/LoaderBar/LoaderBar";
import PageTitle from "components/PageTitle/PageTitle";
import InvertedTable from "components/Table/InvertedTable";
import { useState } from "react";
import { dbGet } from "utils/DBFetchers";

import useStyles from "../styles";
import { GeneralBurnableSelectionForm } from "./GeneralBurnableSelectionForm";
import { filter, map } from "lodash";
const GOAL = 5;

const POLLING_INTERVAL = 3000; // 3 segundos

export default function GeneralBurnableDashboard() {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);

  const adaptResponseToInvertedTable = (data) => {
    const months = Object.keys(data).sort();

    const rowsMap = {};

    months.forEach((month) => {
      const monthData = data[month] || {};
      Object.entries(monthData).forEach(([category, metrics]) => {
        rowsMap[category] = {label: category, category: "divider"};
        Object.entries(metrics).forEach(([metric, value]) => {
          if (!rowsMap[metric]) {
            rowsMap[metric] = {
              label: metric,
              category: "data",
              data: [],
            };
          }

          const numericValue = Number(value);
          rowsMap[metric].data.push(isNaN(numericValue) ? 0 : numericValue);
        });
      });
    });

    const rows = Object.values(rowsMap);
    const columns = months.map((m) => `${m.slice(0, 4)}-${m.slice(4)}`);

    return { rows, columns };
  };

  const renderTables = () => {
    const { rows, columns } = adaptResponseToInvertedTable(data);
    return (
      <>
        <Grid
          item
          xs={12}
          lg={12}
          style={{ marginBottom: "2%", marginTop: "2%", marginLeft: "2.5%" }}
        >
          <Typography variant="h4" className={classes.alignedText}>
            Valores
          </Typography>
          <Divider />
        </Grid>
        <Paper style={{ marginTop: "30px" }}>
          <InvertedTable
            title="Indicador"
            rows={rows}
            columns={columns}
            goal={GOAL}
          />
        </Paper>
      </>
    );
  };

  const renderLoadingSection = () => {
    return (
      <Grid
        item
        container
        justifyContent="center"
        xs={12}
        style={{ paddingTop: "2%" }}
      >
        <LoaderBar />
      </Grid>
    );
  };

  const defineSectionToShow = () => {
    if (isLoading) return renderLoadingSection();
    if (data === null) return <></>;
    return renderTables();
  };

  const onApplyFilters = (filters) => {
    setIsLoading(true);
    const baseUrl = "audit/burnable/general_panel";
    // debugger;
    const fromDatePeriod =
      filters.fromDate.getFullYear() * 100 + (filters.fromDate.getMonth() + 1);
    const toDatePeriod =
      filters.toDate.getFullYear() * 100 + (filters.toDate.getMonth() + 1);

    const rawParams = {
      from_period: fromDatePeriod,
      to_period: toDatePeriod,
      presentation_id: filters.presentation?.id,
      business_area: filters.businessArea,
      brand: filters.brand,
      brick_id: filters.bricks?.id[0] || null,
      vademecum_valid: filters.vademecum_valid,
      distributor_group: filters.canal,
    };
    // Reemplazamos null/undefined por ""
    const sanitizedParams = Object.fromEntries(
      Object.entries(rawParams).map(([key, value]) => [
        key,
        value == null ? "" : value,
      ]),
    );

    const queryParams = new URLSearchParams(sanitizedParams);
    const fullUrl = `${baseUrl}?${queryParams.toString()}`;

    dbGet(fullUrl)
      .then((initialResponse) => {
        const requestId = initialResponse?.id;

        if (!requestId) {
          throw new Error("No se recibió un ID de request");
        }

        // Iniciar polling
        pollRequestStatus(requestId);
      })
      .catch((err) => {
        setIsLoading(false);
        console.error("Error al iniciar la request:", err?.message || "Unknown error");
      });
  };

  const pollRequestStatus = (requestId) => {
    const intervalId = setInterval(() => {
      dbGet(`/request_checker/status?id=${requestId}`)
        .then((statusResponse) => {
          if (statusResponse?.status === "Completed") {
            clearInterval(intervalId);
            setIsLoading(false);
            setData(statusResponse.data);
          } else if (statusResponse?.status === "Failure") {
            clearInterval(intervalId);
            setIsLoading(false);
            console.error("La request falló");
          }
          // Si sigue pendiente, no hacemos nada y esperamos al siguiente intervalo
        })
        .catch((err) => {
          clearInterval(intervalId);
          setIsLoading(false);
          console.error("Error al hacer polling:", err?.message || "Unknown error");
        });
    }, POLLING_INTERVAL);
  };

  return (
    <Grid>
      <PageTitle title="Panel de Control - General Quemables" />
      <Paper elevation={3}>
        <Grid
          container
          xs={12}
          md={12}
          lg={12}
          layout={"row"}
          spacing={"1"}
          style={{ border: "1px" }}
        >
          <GeneralBurnableSelectionForm onApplyFilters={onApplyFilters} />
        </Grid>
      </Paper>
      {defineSectionToShow()}
    </Grid>
  );
}
